import { apiClient } from '../App';

const PAGE_LABELS = {
  '/dashboard': 'Dashboard',
  '/my-actions': 'Today',
  '/leaderboard': 'Leaderboard',
  '/my-summaries': 'Monthly Summaries',
  '/community': 'Community',
  '/profile': 'Profile',
  '/notifications': 'Notifications',
};

const LINK_LABELS = [
  ['RxGRIT-Daily-Action-Blueprint', 'Cheat Sheet PDF'],
  ['beyond-estrogen-guide', 'Beyond Estrogen Guide'],
  ['thatcleanlife.com', 'Recipe Database'],
  ['rxgrit-toolbox', 'RxGRIT Toolbox'],
  ['pb-free-tracking-app', 'Tracking App'],
  ['p.bttr.to', 'Book 1:1 Support'],
  ['mailto:', 'Emailed Yvette'],
];

const send = (payload) => apiClient.post('/activity/track', payload).catch(() => {});

let lastView = { path: null, at: 0 };

export const trackPageView = (path) => {
  const now = Date.now();
  if (lastView.path === path && now - lastView.at < 5000) return;
  lastView = { path, at: now };
  send({ type: 'page_view', label: PAGE_LABELS[path] || path, path });
};

export const trackLinkClick = (anchor) => {
  const href = anchor.getAttribute('href') || '';
  const isExternal = /^(https?:|mailto:)/i.test(href) && !href.startsWith(window.location.origin);
  if (!isExternal) return;
  const known = LINK_LABELS.find(([key]) => href.includes(key));
  const text = (anchor.innerText || '').trim().split('\n')[0].slice(0, 60);
  const isPdf = /\.pdf(\?|$)/i.test(href);
  const label = known ? known[1] : (text || href.replace(/^https?:\/\//, '').slice(0, 60));
  send({ type: isPdf ? 'download' : 'link_click', label, path: href.slice(0, 300) });
};
